<template>
  <div class="content">
    <s-location info title="경유증표 종류"/>

      <div v-html="sitem.cont" class="html_cont"/>
  </div>
</template>


<script>
export default {
  data() {
    return {
      sitem : {},
    }
  },

  created() {
    this.getData()
  },

  methods: {
    getData() {

      this.$ui.httpGet(
        "/proc/N_CMS_SEL_DTL_ADM",
        { seq : '1' }, // TB_CMS 테이블의 [경유증표 종류] 게시글로 고정
        ret => this.sitem = ret.data.rs1[0]
      )

    }
  },
}
</script>
<style scoped>
  /* .html_cont { font-size:14px !important;}
  .html_cont h2 { line-height: 2.0; font-size:12px !important;} */
</style>